import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const swedenFields = {
  sePersonnummer: taxIdFieldConfig("SE", "sePersonnummer"),
  seConfirmPersonnummer: confirmTaxIdFieldConfig("SE", "sePersonnummer"),
};
